export const translations = {
    en: {
        // General
        loading: "Loading...",
        processing: "Processing...",
        error_title: "Error",
        success_title: "Success",
        save: "Save",
        cancel: "Cancel",
        back: "Back",

        // Settings
        settings_title: "Settings",
        language: "Language",
        vibration: "Vibration",
        vibration_on: "On",
        vibration_off: "Off",
        language_en: "English",
        language_ru: "Russian",
        language_uk: "Ukrainian",

        // Welcome Screen
        welcome_title: "HUMAN or BOT",
        welcome_subtitle: "Find the spy. Win the game.",
        welcome_cta: "Ready to challenge AI?",
        start_game: "START GAME",
        rating: "RATING",
        how_to_play: "HOW TO PLAY",
        guest_player: "Guest Player",

        // Rules Screen
        rules_title: "How to play",
        rules_intro_title: "Human or Bot?",
        rules_intro_desc: "Your task is to determine who is a real human and who is an AI.",
        rule_1_title: "1. Chat",
        rule_1_desc: "Ask questions and answer in the general chat. Everyone has 5 minutes.",
        rule_2_title: "2. Analyze",
        rule_2_desc: "Look for unnatural answers, mistakes, or overly perfect phrases.",
        rule_3_title: "3. Vote",
        rule_3_desc: "Choose who to kick. If you guess the bot, you get points.",
        rules_scoring: "Scoring",
        rules_win: "Victory (Bot expelled)",
        rules_loss: "Defeat (Human expelled)",
        rules_tip_title: "Tip:",
        rules_tip_desc: "Bots can pretend to be newbies or make spelling mistakes on purpose. Be vigilant!",
        rules_understood: "Got it",

        // Queue Screen
        queue_title: "Searching for game",
        queue_players: "PLAYERS IN QUEUE",
        queue_retry: "Retry",
        queue_cancel: "Cancel",
        loading_messages: [
            "Connecting to neural network...",
            "Calibrating lie detectors...",
            "Scanning biorhythms...",
            "Searching for worthy opponents...",
            "Loading Turing protocols...",
            "Analyzing behavior patterns...",
            "Syncing with the Matrix...",
            "Updating humor database...",
            "Encrypting comms channels...",
            "Initializing game board..."
        ],

        // Game Screen
        game_status_chat: "CHAT",
        game_status_voting: "VOTING",
        game_status_game: "GAME",
        game_timer: "TIMER",
        game_you: "You",
        game_player: "Player",
        game_bot: "Bot",
        game_unknown: "Unknown",
        game_input_placeholder: "Message...",
        game_silence: "Silence on air...",

        // Vote Screen
        vote_title: "WHO IS A BOT? 🤖",
        vote_subtitle: "Analyze the dialogue and make a choice",
        vote_timer_left: "Left",
        vote_suspect: "Suspect",
        vote_skip: "SKIP",
        vote_action: "VOTE",
        vote_waiting_title: "Vote accepted",
        vote_waiting_desc: "Waiting for other players...",

        // Results Screen
        results_title: "MISSION RESULTS 🎯",
        results_bot_revealed: "{name} was a bot!",
        results_bot_hidden: "Bot was not revealed",
        results_stats: "Participants Stats",
        results_guessed: "GUESSED",
        results_bot_badge: "BOT",
        results_vote_summary: "Vote Summary",
        results_vote_against: "against",
        results_vote_skipped: "Skipped",
        results_menu: "MENU",
        results_again: "PLAY AGAIN",

        // Rating Screen
        rating_title: "Rating",
        league_wooden: "Wooden",
        league_bronze: "Bronze",
        league_silver: "Silver",
        league_gold: "Gold",
        empty_league: "This league is empty yet.\nBe the first legend!",
        loading_data: "LOADING DATA...",
        your_rating: "YOUR RATING",
        to_battle: "TO BATTLE",
        you: "(You)",

        // Game Phases
        searching: "SEARCHING FOR PLAYERS...",

        // Profile Screen
        profile_title: "Profile",
        profile_stats: "Game Statistics",
        profile_wins: "Wins",
        profile_losses: "Losses",
        profile_win_rate: "Win Rate",
        profile_games: "Games Played",
        profile_tg_id: "Telegram ID",
        league_title: "League",
    },
    ru: {
        // General
        loading: "Загрузка...",
        processing: "Обработка...",
        error_title: "Ошибка",
        success_title: "Успешно",
        save: "Сохранить",
        cancel: "Отмена",
        back: "Назад",

        // Settings
        settings_title: "Настройки",
        language: "Язык",
        vibration: "Вибрация",
        vibration_on: "Вкл",
        vibration_off: "Выкл",
        language_en: "English",
        language_ru: "Русский",
        language_uk: "Українська",

        // Welcome Screen
        welcome_title: "HUMAN or BOT",
        welcome_subtitle: "Найди шпиона. Победи в игре.",
        welcome_cta: "Готов бросить вызов ИИ?",
        start_game: "НАЧАТЬ ИГРУ",
        rating: "РЕЙТИНГ",
        how_to_play: "КАК ИГРАТЬ",
        guest_player: "Гость",

        // Rules Screen
        rules_title: "Как играть",
        rules_intro_title: "Человек или Бот?",
        rules_intro_desc: "Твоя задача — определить, кто из собеседников реальный человек, а кто искусственный интеллект.",
        rule_1_title: "1. Общайся",
        rule_1_desc: "Задавай вопросы и отвечай в общем чате. У всех есть 5 минут.",
        rule_2_title: "2. Анализируй",
        rule_2_desc: "Ищи неестественные ответы, ошибки или слишком идеальные фразы.",
        rule_3_title: "3. Голосуй",
        rule_3_desc: "Выбери, кого исключить. Если угадаешь бота — получишь очки.",
        rules_scoring: "Начисление очков",
        rules_win: "Победа (Бот изгнан)",
        rules_loss: "Поражение (Человек изгнан)",
        rules_tip_title: "Совет:",
        rules_tip_desc: "Боты могут притворяться новичками или делать орфографические ошибки специально. Будь бдителен!",
        rules_understood: "Понятно",

        // Queue Screen
        queue_title: "Поиск игры",
        queue_players: "ИГРОКОВ В ОЧЕРЕДИ",
        queue_retry: "Повторить попытку",
        queue_cancel: "Отмена",
        loading_messages: [
            "Подключаемся к нейросети...",
            "Калибровка детекторов лжи...",
            "Сканирование биоритмов...",
            "Поиск достойных соперников...",
            "Загрузка протоколов Тьюринга...",
            "Анализ паттернов поведения...",
            "Синхронизация с матрицей...",
            "Обновление базы данных юмора...",
            "Шифрование каналов связи...",
            "Инициализация игрового поля..."
        ],

        // Game Screen
        game_status_chat: "ОБЩЕНИЕ",
        game_status_voting: "ГОЛОСОВАНИЕ",
        game_status_game: "ИГРА",
        game_timer: "ТАЙМЕР",
        game_you: "Вы",
        game_player: "Игрок",
        game_bot: "Бот",
        game_unknown: "Неизвестный",
        game_input_placeholder: "Сообщение...",
        game_silence: "Тишина в эфире...",

        // Vote Screen
        vote_title: "КТО ЗДЕСЬ БОТ? 🤖",
        vote_subtitle: "Проанализируйте диалог и сделайте выбор",
        vote_timer_left: "Осталось",
        vote_suspect: "Подозреваемый",
        vote_skip: "ПРОПУСТИТЬ",
        vote_action: "ГОЛОСОВАТЬ",
        vote_waiting_title: "Голос принят",
        vote_waiting_desc: "Ожидаем остальных игроков...",

        // Results Screen
        results_title: "ИТОГИ МИССИИ 🎯",
        results_bot_revealed: "{name} был ботом!",
        results_bot_hidden: "Бот не раскрыт",
        results_stats: "Статистика участников",
        results_guessed: "УГАДАЛ",
        results_bot_badge: "BOT",
        results_vote_summary: "Голосование",
        results_vote_against: "против",
        results_vote_skipped: "Пропустил",
        results_menu: "В МЕНЮ",
        results_again: "ЕЩЕ РАЗ",

        // Rating Screen
        rating_title: "Рейтинг",
        league_wooden: "Деревянная",
        league_bronze: "Бронзовая",
        league_silver: "Серебряная",
        league_gold: "Золотая",
        empty_league: "В этой лиге пока пусто.\nСтань легендой первым!",
        loading_data: "ЗАГРУЗКА ДАННЫХ...",
        your_rating: "ВАШ РЕЙТИНГ",
        to_battle: "В БОЙ",
        you: "(Вы)",

        // Game Phases
        searching: "ПОИСК ИГРОКОВ...",

        // Profile Screen
        profile_title: "Профиль",
        profile_stats: "Статистика игр",
        profile_wins: "Победы",
        profile_losses: "Поражения",
        profile_win_rate: "Винрейт",
        profile_games: "Всего игр",
        profile_tg_id: "Telegram ID",
        league_title: "Лига",
    },
    uk: {
        // General
        loading: "Завантаження...",
        processing: "Обробка...",
        error_title: "Помилка",
        success_title: "Успішно",
        save: "Зберегти",
        cancel: "Скасувати",
        back: "Назад",

        // Settings
        settings_title: "Налаштування",
        language: "Мова",
        vibration: "Вібрація",
        vibration_on: "Увімк",
        vibration_off: "Вимк",
        language_en: "English",
        language_ru: "Русский",
        language_uk: "Українська",

        // Welcome Screen
        welcome_title: "HUMAN or BOT",
        welcome_subtitle: "Знайди шпигуна. Переможи у грі.",
        welcome_cta: "Готовий кинути виклик ШІ?",
        start_game: "ПОЧАТИ ГРУ",
        rating: "РЕЙТИНГ",
        how_to_play: "ЯК ГРАТИ",
        guest_player: "Гість",

        // Rules Screen
        rules_title: "Як грати",
        rules_intro_title: "Людина чи Бот?",
        rules_intro_desc: "Твоє завдання — визначити, хто зі співрозмовників реальна людина, а хто штучний інтелект.",
        rule_1_title: "1. Спілкуйся",
        rule_1_desc: "Задавай питання та відповідай у загальному чаті. У всіх є 5 хвилин.",
        rule_2_title: "2. Аналізуй",
        rule_2_desc: "Шукай неприродні відповіді, помилки або занадто ідеальні фрази.",
        rule_3_title: "3. Голосуй",
        rule_3_desc: "Обери, кого виключити. Якщо вгадаєш бота — отримаєш бали.",
        rules_scoring: "Нарахування балів",
        rules_win: "Перемога (Бот вигнаний)",
        rules_loss: "Поразка (Людина вигнана)",
        rules_tip_title: "Порада:",
        rules_tip_desc: "Боти можуть прикидатися новачками або робити орфографічні помилки навмисно. Будь пильним!",
        rules_understood: "Зрозуміло",

        // Queue Screen
        queue_title: "Пошук гри",
        queue_players: "ГРАВЦІВ У ЧЕРЗІ",
        queue_retry: "Спробувати ще",
        queue_cancel: "Скасувати",
        loading_messages: [
            "Підключення до нейромережі...",
            "Калібрування детекторів брехні...",
            "Сканування біоритмів...",
            "Пошук гідних суперників...",
            "Завантаження протоколів Тьюринга...",
            "Аналіз патернів поведінки...",
            "Синхронізація з матрицею...",
            "Оновлення бази даних гумору...",
            "Шифрування каналів зв'язку...",
            "Ініціалізація ігрового поля..."
        ],

        // Game Screen
        game_status_chat: "СПІЛКУВАННЯ",
        game_status_voting: "ГОЛОСУВАННЯ",
        game_status_game: "ГРА",
        game_timer: "ТАЙМЕР",
        game_you: "Ви",
        game_player: "Гравець",
        game_bot: "Бот",
        game_unknown: "Невідомий",
        game_input_placeholder: "Повідомлення...",
        game_silence: "Тиша в ефірі...",

        // Vote Screen
        vote_title: "ХТО ТУТ БОТ? 🤖",
        vote_subtitle: "Проаналізуйте діалог і зробіть вибір",
        vote_timer_left: "Залишилось",
        vote_suspect: "Підозрюваний",
        vote_skip: "ПРОПУСТИТИ",
        vote_action: "ГОЛОСУВАТИ",
        vote_waiting_title: "Голос прийнято",
        vote_waiting_desc: "Чекаємо на інших гравців...",

        // Results Screen
        results_title: "ПІДСУМКИ МІСІЇ 🎯",
        results_bot_revealed: "{name} був ботом!",
        results_bot_hidden: "Бот не розкритий",
        results_stats: "Статистика учасників",
        results_guessed: "ВГАДАВ",
        results_bot_badge: "BOT",
        results_vote_summary: "Голосування",
        results_vote_against: "проти",
        results_vote_skipped: "Пропустив",
        results_menu: "В МЕНЮ",
        results_again: "ЩЕ РАЗ",

        // Rating Screen
        rating_title: "Рейтинг",
        league_wooden: "Дерев'яна",
        league_bronze: "Бронзова",
        league_silver: "Срібна",
        league_gold: "Золота",
        empty_league: "У цій лізі поки порожньо.\nСтань легендою першим!",
        loading_data: "ЗАВАНТАЖЕННЯ ДАНИХ...",
        your_rating: "ВАШ РЕЙТИНГ",
        to_battle: "ДО БОЮ",
        you: "(Ви)",

        // Game Phases
        searching: "ПОШУК ГРАВЦІВ...",

        // Profile Screen
        profile_title: "Профіль",
        profile_stats: "Статистика ігор",
        profile_wins: "Перемоги",
        profile_losses: "Поразки",
        profile_win_rate: "Вінрейт",
        profile_games: "Усього ігор",
        profile_tg_id: "Telegram ID",
        league_title: "Ліга",
    }
};
